import * as React from "react";
import {
    Button,
    Grid,
    TextField,
    Select,
    MenuItem,
    FormControl,
    InputLabel
} from "@material-ui/core";
import { API } from "aws-amplify";
import { LoadingSpinner } from "../../../utils/LoadingSpinner";
import {useEffect, useState} from "react";
import { useCommonStyles } from './styles';

enum HubsProgram {
    ASSEMBIA = "ASSEMBIA",
    ASSISTRX = "ASSISTRX",
    EVERSANA = "EVERSANA"
}

const CreateHubsPaymentInstrumentSection: React.FC = () => {
    const classes = useCommonStyles();
    const [program, setProgram] = useState<HubsProgram | ''>('');
    const [putPaymentInstrumentRequest, setPutPaymentInstrumentRequest] = useState('');
    const [formSubmitted, setFormSubmitted] = useState(false);
    const [resultSuccessful, setResultSuccessful] = useState(false);
    const [partnerPaymentInstrumentId, setPartnerPaymentInstrumentId] = useState('');

    useEffect(() => {
        setPutPaymentInstrumentRequest(getSampleJSON());
    }, []);

    const getSampleJSON = (): string => {
        return JSON.stringify({
            "partnerPatientId": "",
            "partnerPaymentInstrumentId": "",
            "paymentMethod": "CARD",
            "cardDetails": {
                "cardHolderName": "",
                "encryptedCardNumber": "",
                "expirationMonth": "",
                "expirationYear": ""
            },
            "billingAddress": {
                "addressLine1": "",
                "city": "",
                "state": "",
                "zipCode": "",
                "countryCode": "US"
            }
        }, null, 2);
    };

    const handleValidation = (): boolean => {
        if (!program) {
            alert("Please select a program");
            return false;
        }
        if (!putPaymentInstrumentRequest) {
            alert("Please enter a valid payment instrument request JSON");
            return false;
        }
        try {
            JSON.parse(putPaymentInstrumentRequest);
        } catch (e) {
            alert("Invalid JSON format");
            return false;
        }
        return true;
    };

    const handleSubmit = async () => {
        if (handleValidation()) {
            setFormSubmitted(true);

            const apiName = "ApaqPortalAPI";
            const path = "/hubs/payment-instrument/create";

            const requestBody = {
                program,
                putPaymentInstrumentRequest
            };

            console.log("Selected Program:", program);
            console.log("Full Request Body:", requestBody);

            try {
                const response = await API.post(apiName, path, { body: requestBody });
                console.log("Success response:", response);
                setResultSuccessful(true);
                setPartnerPaymentInstrumentId(response.partnerPaymentInstrumentId);
            } catch (error) {
                console.error("Error details:", error);
                alert(`Error creating payment instrument: ${error.response?.data?.message || error.message || "Unknown error"}`);
            } finally {
                setFormSubmitted(false);
            }
        }
    };

    return (
        <div className={classes.root}>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <h1>Create HUBS Payment Instrument</h1>
                </Grid>

                <Grid item xs={12}>
                    <FormControl className={classes.formControl}>
                        <InputLabel>Program *</InputLabel>
                        <Select
                            value={program}
                            onChange={(e) => setProgram(e.target.value as HubsProgram)}
                            required
                        >
                            {Object.values(HubsProgram).map((prog) => (
                                <MenuItem key={prog} value={prog}>
                                    {prog}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>

                <Grid item xs={12}>
                    <TextField
                        label="Put Payment Instrument Request (JSON) *"
                        multiline
                        rows={20}
                        value={putPaymentInstrumentRequest}
                        onChange={(e) => setPutPaymentInstrumentRequest(e.target.value)}
                        variant="outlined"
                        className={classes.textField}
                        required
                        placeholder='Enter JSON for putPaymentInstrumentRequest'
                    />
                </Grid>

                <Grid item xs={12}>
                    <Button
                        variant="outlined"
                        color="default"
                        onClick={handleSubmit}
                    >
                        Create Payment Instrument
                    </Button>
                </Grid>

                {formSubmitted && (
                    <Grid item xs={12}>
                        <LoadingSpinner />
                    </Grid>
                )}

                {resultSuccessful && partnerPaymentInstrumentId && (
                    <Grid item xs={12}>
                        <div className={classes.successMessage}>
                            Partner Payment Instrument ID: {partnerPaymentInstrumentId}
                        </div>
                    </Grid>
                )}
            </Grid>
        </div>
    );
};

export default CreateHubsPaymentInstrumentSection;
